import { render, staticRenderFns } from "./SelectExternalFriend.vue?vue&type=template&id=7ce82450&scoped=true&"
import script from "./SelectExternalFriend.vue?vue&type=script&lang=js&"
export * from "./SelectExternalFriend.vue?vue&type=script&lang=js&"
import style0 from "./SelectExternalFriend.vue?vue&type=style&index=0&id=7ce82450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce82450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce82450')) {
      api.createRecord('7ce82450', component.options)
    } else {
      api.reload('7ce82450', component.options)
    }
    module.hot.accept("./SelectExternalFriend.vue?vue&type=template&id=7ce82450&scoped=true&", function () {
      api.rerender('7ce82450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/newChat/SelectExternalFriend.vue"
export default component.exports